module.exports = __webpack_public_path__ + "img/bin-c-2-w.9ccd95c5.svg";